import App from '@/App.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: 'AIzaSyA1KHfsjH-sRUvpquCoUuOKPfLdpKuu5w8',
  authDomain: 'cecrops-smovin.firebaseapp.com',
  databaseURL: 'https://cecrops-smovin.firebaseio.com',
  projectId: 'cecrops-smovin',
  storageBucket: 'cecrops-smovin.appspot.com',
  messagingSenderId: '1072726025783',
  appId: '1:1072726025783:web:fceae73c3c6d33a49541b2'
})

Vue.use(VueRouter)

new Vue({
  render: h => h(App)
}).$mount('#app')
